var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitcherGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    preserveAspectRatio: "xMidYMid meet",
    fill: "white",
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H18V8H14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H8V8H4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4H28V8H24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H18V18H14z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14H8V18H4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H28V18H24z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24H18V28H14z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H8V28H4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24H28V28H24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitcherGrid);
export default __webpack_public_path__ + "static/media/switcher-grid.3ba47851afdcdbd2bd67d71f4f25d2d9.svg";
export { ForwardRef as ReactComponent };